import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import Folder from '../entities/folder'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import FoldersRequest from '../requests/folders-request'
import pagingWatcher from '@/common/pagination/utils/paging-watcher'
import foldersService from '../services/folders-service'
import FolderDialog from '../components/folder-dialog'

@Component
export default class Folders extends Vue {
  @Ref()
  private dialog!: FolderDialog

  private loading: boolean = false
  private folders: Folder[] = []

  private request = new FoldersRequest()

  @Watch('request.paging', { deep: true })
  private paginationChanged = pagingWatcher(this.fetchAll)

  private async fetchAll() {
    this.loading = true
    const response = await foldersService.findAllAsync(this.request)
    this.folders = response.items
    this.request.paging.totalItems = response.totalItems
    this.loading = false
  }

  private create() {
    this.dialog.openNew(new Folder())
  }

  private edit(stakeholder: Folder) {
    this.dialog.openEdit(stakeholder)
  }

  private async deleteFolder(folder: Folder) {
    await foldersService.deleteAsync(folder)
    await this.fetchAll()
  }

  private async createConfirm(folder: Folder) {
    if (await foldersService.createAsync(folder)) {
      await this.fetchAll()
      this.dialog.close()
    }
  }
  private async editConfirm(folder: Folder) {
    if (await foldersService.updateAsync(folder)) {
      await this.fetchAll()
      this.dialog.close()
    }
  }

  private async created() {
    this.request.paging.sortBy = ['name']
    this.request.paging.sortDesc = [false]

    await this.fetchAll()
  }
}
